import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSoftException = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10 12C9.4375 12 9 12.4688 9 13C9 13.5625 9.4375 14 10 14C10.5312 14 11 13.5625 11 13C11 12.4688 10.5312 12 10 12ZM10 6C9.5625 6 9.25 6.34375 9.25 6.75V10.25C9.25 10.6875 9.5625 11 10 11C10.4062 11 10.75 10.6875 10.75 10.25V6.75C10.75 6.34375 10.4062 6 10 6Z",
		fill: "#9B5A01"
	})
});
export default SvgSoftException;
